import React from "react";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import "./partner.css";

const logos = [
  {
    name: "Quantum",
    src: "https://www.quantum.com/globalassets/redesign2021/quantum-logo-gradient.svg",
    alt: "Quantum logo",
  },
  {
    name: "Molex",
    src: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Molex-Logo.svg",
    alt: "Molex logo",
  },
  {
    name: "Delta",
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRu4S1ydogDch4lD5vWpe0XV8YIXwnlX3RQ2g&s",
    alt: "Delta logo",
  },
  {
    name: "Creative Newtech",
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwzD2KITSAWnlKFOv9tbjgZoSeiesJR8Zvyw&s",
    alt: "Creative Newtech logo",
  },
];

const PartnerSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <section
      className="partner-section-shell"
      style={{
        padding: isMobile ? "3rem 1.5rem" : "6rem 4rem",
      }}
    >
      <div className="partner-glow partner-glow-left" />
      <div className="partner-glow partner-glow-right" />

      <div className="container text-center partner-content">
        <h2
          style={{
            fontSize: isMobile ? "26px" : "38px",
            fontWeight: 700,
            color: "#1E1B4B",
            marginBottom: "15px",
          }}
        >
          Trusted Technology Partners
        </h2>

        <p
          style={{
            maxWidth: "700px",
            margin: "0 auto 40px auto",
            color: "#6B7280",
            fontSize: isMobile ? "14px" : "16px",
            lineHeight: isMobile ? "26px" : "32px",
          }}
        >
          We collaborate with leading OEMs and technology providers to deliver
          dependable data centre, networking, wireless, and electronics
          infrastructure solutions for enterprise clients.
        </p>

        <div className="row align-items-center justify-content-center">
          {logos.map((logo, index) => (
            <div
              key={logo.name}
              className="col-6 col-md-3 mb-4 d-flex justify-content-center align-items-center"
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="partner-logo"
                style={{
                  animationDelay: `${index * 0.12}s`,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerSection;
